(() => {
  const rootPath = () => {
    try {
      const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r.endsWith('/') ? r : `${r}/`;
    } catch (_) {
      return '/';
    }
  };

  const isHomePath = (pathname) => {
    const root = rootPath().replace(/\/$/, '') || '';
    const path = (pathname || '/').replace(/\/$/, '') || '';
    return path === root || path === '';
  };

  const prefetchHome = () => {
    const href = rootPath();
    if (document.querySelector(`link[data-chikas-prefetch-home][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.setAttribute('data-chikas-prefetch-home', '');
    document.head.appendChild(link);
  };

  const isHomeNavLink = (a) => {
    if (!a || !a.href) return false;
    try {
      const url = new URL(a.href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      if (!isHomePath(url.pathname)) return false;
      /* Solo Inicio / logo — no #nuestro-universo etc. con path home + hash de sección lejana */
      return true;
    } catch (_) {
      return false;
    }
  };

  document.addEventListener(
    'click',
    (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || !isHomeNavLink(a)) return;

      let url;
      try {
        url = new URL(a.href, window.location.origin);
      } catch (_) {
        return;
      }

      /* Ya estás en inicio: no recargar (eso causa la mini-carga fea) */
      if (isHomePath(window.location.pathname)) {
        e.preventDefault();
        const hash = url.hash;
        if (hash && hash.length > 1) {
          const target = document.querySelector(hash);
          if (target) {
            target.scrollIntoView({ behavior: 'auto', block: 'start' });
            history.replaceState(null, '', hash);
            return;
          }
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        if (window.location.hash) history.replaceState(null, '', window.location.pathname + window.location.search);
        return;
      }

      prefetchHome();
    },
    true
  );

  document.addEventListener(
    'pointerenter',
    (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (a && isHomeNavLink(a)) prefetchHome();
    },
    true
  );

  /* Prefetch suave al cargar cualquier página interna */
  if (!isHomePath(window.location.pathname)) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchHome, { timeout: 2500 });
    } else {
      setTimeout(prefetchHome, 1200);
    }
  }
})();
